/**
 * Public Routes — Auth, legal, about, static pages
 * No authentication required for any of these routes
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';

// Auth
import { Login, Register } from '../pages/Auth';
import AutoLogin from '../pages/AutoLogin';
import VerifyEmail from '../pages/VerifyEmail';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';

// Legal & About
import Privacy from '../pages/Privacy';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import AboutPage from '../pages/AboutPage';
import ClubStoryPage from '../pages/ClubStoryPage';
import FuturePlansPage from '../pages/FuturePlansPage';
import ContactPage from '../pages/ContactPage';
import BylawsPage from '../pages/BylawsPage';
import DisclaimerPage from '../pages/DisclaimerPage';
import TrustPage from '../pages/TrustPage';
import RedeemPage from '../pages/RedeemPage';
import PartnerPromoFlyer from '../pages/PartnerPromoFlyer';
import ServiceAgreementPage from '../pages/ServiceAgreementPage';
import BetaTesterAgreement from '../pages/BetaTesterAgreement';
import CreditsPage from '../pages/CreditsPage';
import FeaturesPage from '../pages/FeaturesPage';
import BringFidoPreview from '../pages/BringFidoPreview';
import PartnerPage from '../pages/PartnerPage';
import DiscoverPage from '../pages/DiscoverPage';

// Public content
import ClubBlog from '../pages/ClubBlog';
import ClubRequests from '../pages/ClubRequests';
import ClubDirectory from '../pages/ClubDirectory';
import TestCaptcha from '../pages/TestCaptcha';
import PatronsPage from '../pages/PatronsPage';
import BetaAgreementPage from '../pages/BetaAgreementPage';
import FAQ from '../pages/FAQ';
import Membership from '../pages/Membership';
import LaunchChecklist from '../pages/LaunchChecklist';
import CostRoadmap from '../pages/CostRoadmap';
import BusinessFinancials from '../pages/BusinessFinancials';
import FeatureRoadmap from '../pages/FeatureRoadmap';
import CommunityPulse from '../pages/CommunityPulse';
import ResearchLibrary from '../pages/ResearchLibrary';
import BreedQuiz from '../pages/BreedQuiz';
import NgoJoinPage from '../pages/NgoJoinPage';
import NgoPromoPage from '../pages/NgoPromoPage';
import JoinNgoPage from '../pages/JoinNgoPage';
import PartnerPublicPage from '../pages/PartnerPublicPage';
import NgoManageDashboard from '../pages/NgoManageDashboard';
import HandoutCardPreview from '../pages/HandoutCardPreview';
import PetProfile from '../pages/PetProfile';

// Club pages
import Landing from '../pages/Landing';
import WorldPetsLanding from '../pages/WorldPetsLanding';
import ClubHomepage from '../pages/ClubHomepage';
import ClubNetworkLanding from '../pages/ClubNetworkLanding';

export function getPublicRoutes(Layout, RootPage) {
  return [
    // Root & Club landings
    <Route key="/" path="/" element={<Layout showNav={true}><RootPage /></Layout>} />,
    <Route key="/club/aadc" path="/club/all-american-dog-club" element={<Layout showNav={true}><Landing /></Layout>} />,
    <Route key="/club/wp" path="/club/worldpets" element={<Layout showNav={true}><WorldPetsLanding /></Layout>} />,
    <Route key="/club/:slug" path="/club/:slug" element={<Layout showNav={true}><ClubHomepage /></Layout>} />,

    // Auth
    <Route key="/login" path="/login" element={<Login />} />,
    <Route key="/register" path="/register" element={<Register />} />,
    <Route key="/auto-login" path="/auto-login" element={<AutoLogin />} />,
    <Route key="/verify-email" path="/verify-email" element={<VerifyEmail />} />,
    <Route key="/forgot-password" path="/forgot-password" element={<ForgotPassword />} />,
    <Route key="/reset-password" path="/reset-password" element={<ResetPassword />} />,

    // Legal & About
    <Route key="/privacy" path="/privacy" element={<Layout><Privacy /></Layout>} />,
    <Route key="/privacy-policy" path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />,
    <Route key="/trust" path="/trust" element={<Layout><TrustPage /></Layout>} />,
    <Route key="/redeem" path="/redeem" element={<Layout><RedeemPage /></Layout>} />,
    <Route key="/redeem/:code" path="/redeem/:code" element={<Layout><RedeemPage /></Layout>} />,
    <Route key="/partner-promo/:code" path="/partner-promo/:code" element={<PartnerPromoFlyer />} />,
    <Route key="/about" path="/about" element={<Layout><AboutPage /></Layout>} />,
    <Route key="/about/story" path="/about/story" element={<Layout><ClubStoryPage /></Layout>} />,
    <Route key="/about/future" path="/about/future" element={<Layout><FuturePlansPage /></Layout>} />,
    <Route key="/about/bylaws" path="/about/bylaws" element={<Layout><BylawsPage /></Layout>} />,
    <Route key="/about/service-agreement" path="/about/service-agreement" element={<Layout><ServiceAgreementPage /></Layout>} />,
    <Route key="/about/beta-agreement" path="/about/beta-agreement" element={<Layout><BetaTesterAgreement /></Layout>} />,
    <Route key="/contact" path="/contact" element={<Layout><ContactPage /></Layout>} />,
    <Route key="/disclaimer" path="/disclaimer" element={<Layout><DisclaimerPage /></Layout>} />,
    <Route key="/credits" path="/credits" element={<Layout><CreditsPage /></Layout>} />,
    <Route key="/features" path="/features" element={<Layout><FeaturesPage /></Layout>} />,
    <Route key="/discover" path="/discover" element={<Layout><DiscoverPage /></Layout>} />,
    <Route key="/discover/:city" path="/discover/:city" element={<Layout><DiscoverPage /></Layout>} />,

    // Public content
    <Route key="/clubs" path="/clubs" element={<Layout><ClubDirectory /></Layout>} />,
    <Route key="/club-blog" path="/club-blog" element={<Layout><ClubBlog /></Layout>} />,
    <Route key="/club-blog/:postId" path="/club-blog/:postId" element={<Layout><ClubBlog /></Layout>} />,
    <Route key="/request-club" path="/request-club" element={<Layout><ClubRequests /></Layout>} />,
    <Route key="/test-captcha" path="/test-captcha" element={<Layout><TestCaptcha /></Layout>} />,
    <Route key="/patrons" path="/patrons" element={<Layout><PatronsPage /></Layout>} />,
    <Route key="/beta-agreement" path="/beta-agreement" element={<Layout><BetaAgreementPage /></Layout>} />,
    <Route key="/faq" path="/faq" element={<Layout><FAQ /></Layout>} />,
    <Route key="/membership" path="/membership" element={<Layout><Membership /></Layout>} />,
    <Route key="/launch-checklist" path="/launch-checklist" element={<Layout><LaunchChecklist /></Layout>} />,
    <Route key="/invest" path="/invest" element={<Layout><CostRoadmap /></Layout>} />,
    <Route key="/financials" path="/financials" element={<Layout><BusinessFinancials /></Layout>} />,
    <Route key="/roadmap" path="/roadmap" element={<Layout><FeatureRoadmap /></Layout>} />,
    <Route key="/community-pulse" path="/community-pulse" element={<Layout><CommunityPulse /></Layout>} />,
    <Route key="/research-library" path="/research-library" element={<Layout><ResearchLibrary /></Layout>} />,
    <Route key="/breed-quiz" path="/breed-quiz" element={<Layout><BreedQuiz /></Layout>} />,
    <Route key="/changelog" path="/changelog" element={<Navigate to="/beta-feedback?tab=changelog" replace />} />,
    <Route key="/travel-preview" path="/travel-preview" element={<Layout><BringFidoPreview /></Layout>} />,
    <Route key="/p/:slug" path="/p/:slug" element={<Layout><PartnerPage /></Layout>} />,
    <Route key="/ngo/join" path="/ngo/join" element={<Layout><NgoJoinPage /></Layout>} />,
    <Route key="/ngo/manage/:slug" path="/ngo/manage/:slug" element={<Layout><NgoManageDashboard /></Layout>} />,
    <Route key="/ngo/:slug" path="/ngo/:slug" element={<Layout><NgoPromoPage /></Layout>} />,
    <Route key="/partners/:slug" path="/partners/:slug" element={<Layout><PartnerPublicPage /></Layout>} />,
    <Route key="/preview/handout/:slug" path="/preview/handout/:slug" element={<HandoutCardPreview />} />,
    <Route key="/join/:slug" path="/join/:slug" element={<Layout><JoinNgoPage /></Layout>} />,
    <Route key="/pets/:id" path="/pets/:id" element={<Layout><PetProfile /></Layout>} />,
  ];
}
